import styled from 'styled-components'

export const Container = styled.main`
  width: 100%;
  min-height: 100vh;
  display: flex;

  > div {
    flex: 1;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    padding: 2rem 1.875rem;

    section {
      min-height: 100vh;
    }

    img {
      width: 10rem;
      /* margin-bottom: 2rem; */
    }

    footer {
      text-align: center;
      margin-top: 2rem;

      a {
        color: orange;
      }
    }
  }
`

export const Install = styled.div`
  position: absolute;
  top: 5rem;
  left: 5%;
`
